import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMistakes } from 'modules/mistakes';

/** How many wrong answers still wait in Xatolarim, linking to them. Nothing to show when there are none. */
export function HomeMistakes() {
  const { t } = useTranslation();
  const { data } = useMistakes();
  const count = data?.items.length ?? 0;
  if (count === 0) return null;

  return (
    <Link
      to="/portal/mistakes"
      className="flex h-full flex-col justify-between gap-4 rounded-[20px] border border-border bg-card p-5 transition-colors hover:border-foreground/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring md:p-6"
    >
      <div>
        <p className="font-mono text-[11px] font-bold uppercase tracking-[0.14em] text-muted-foreground">{t('portal.home_mistakes_title')}</p>
        <p className="mt-2.5 font-display text-[44px] font-extrabold leading-none tracking-[-0.04em] text-foreground tabular-nums">{count}</p>
        <p className="mt-1.5 text-[13px] text-muted-foreground">{t('portal.home_mistakes_hint', { count })}</p>
      </div>
      <span className="text-[13.5px] font-bold text-foreground">{t('portal.home_mistakes_cta')} →</span>
    </Link>
  );
}

export default HomeMistakes;
